module.exports = __webpack_public_path__ + "static/iphone1-bf27a087e28e9171c35582e8cbca4e0f.png";